import { Component, OnDestroy} from '@angular/core';
import { faGlobe as falGlobe } from '@fortawesome/free-solid-svg-icons/faGlobe';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { unsubscribe } from '../../utils/helpers';
import { TranslationHelperService } from '../../services/translations/translation-helper.service';

@Component({
  standalone: false,
  selector: 'app-language-selector',
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.scss']
})
export class LanguageSelectorComponent implements OnDestroy {

  readonly icons = {
    falGlobe };

  languages: string[] = this.translationHelper.languages;
  language: string = this.getInitialLanguage();

  private subscriptions: Subscription[] = [];

  ngOnDestroy(): void {
    unsubscribe(this.subscriptions);
  }

  constructor(
    protected translationHelper: TranslationHelperService,
    private readonly router: Router,
  ) {
    unsubscribe(this.subscriptions);
    this.subscriptions.push(
      this.translationHelper.getLanguage().subscribe(
        language => this.language = language,
        err => console.log(this.constructor.name, 'getLanguage', err),
      ),
    );
  }

  changeLang(lang: string): void {
    if (lang === this.language) {
      return;
    }

    // Let the route resolver update translations; this keeps a language
    // selection to one navigation, including from nested project routes.
    const url = this.router.parseUrl(this.router.url);
    const primaryOutlet = url.root.children.primary;
    if (primaryOutlet?.segments.length) {
      primaryOutlet.segments[0].path = lang;
      this.router.navigateByUrl(url);
    }
  }

  private getInitialLanguage(): string {
    const routeLanguage = this.router.url.split('?')[0].split('/').filter(Boolean)[0];

    return this.languages.includes(routeLanguage)
      ? routeLanguage
      : this.translationHelper.getDefaultLanguage();
  }
}
